const mockListings = [
  {
    _id: '1',
    title: 'BMW M5 Competition',
    description: 'Samochód w idealnym stanie technicznym, pierwszy właściciel',
    price: 450000,
    year: 2021,
    mileage: 25000,
    fuelType: 'Benzyna',
    power: '625 KM',
    featured: true,
    images: ['/images/auto-788747_1280.jpg']
  },
  {
    _id: '2',
    title: 'Audi RS6 Avant',
    description: 'Bezwypadkowy, serwisowany w ASO, gwarancja',
    price: 520000,
    year: 2022,
    mileage: 15000,
    fuelType: 'Benzyna',
    power: '600 KM',
    featured: true,
    images: ['/images/car-1880381_640.jpg']
  },
  {
    _id: '3',
    title: 'Mercedes AMG GT',
    description: 'Pierwszy właściciel, książka serwisowa, idealny stan',
    price: 650000,
    year: 2023,
    mileage: 5000,
    fuelType: 'Benzyna',
    power: '585 KM',
    featured: true,
    images: ['/images/car-932455_1920.jpg']
  },
  {
    _id: '3',
    title: 'Mercedes AMG GT',
    description: 'Pierwszy właściciel, książka serwisowa, idealny stan',
    price: 650000,
    year: 2023,
    mileage: 5000,
    fuelType: 'Benzyna',
    power: '585 KM',
    featured: true,
    images: ['/images/car-932455_1920.jpg']
  },
  {
    _id: '3',
    title: 'Mercedes AMG GT',
    description: 'Pierwszy właściciel, książka serwisowa, idealny stan',
    price: 650000,
    year: 2023,
    mileage: 5000,
    fuelType: 'Benzyna',
    power: '585 KM',
    featured: true,
    images: ['/images/car-932455_1920.jpg']
  },
  {
    _id: '4',
    title: 'Dodge Challenger',
    description: 'Stan idealny, sprowadzony z USA, pełna dokumentacja',
    price: 350000,
    year: 2022,
    mileage: 20000,
    fuelType: 'Benzyna',
    power: '717 KM',
    featured: false,
    images: ['/images/challenger-5880009_1920.jpg']
  },
  {
    _id: '5',
    title: 'Ford Mustang GT',
    description: 'V8, manualną skrzynia, bezwypadkowy',
    price: 280000,
    year: 2021,
    mileage: 35000,
    fuelType: 'Benzyna',
    power: '450 KM',
    featured: false,
    images: ['/images/dodge-challenger-8214392_1280.jpg']
  },
  {
    _id: '6',
    title: 'Toyota GR Yaris',
    description: 'Limitowana edycja, stan salonowy',
    price: 180000,
    year: 2022,
    mileage: 12000,
    fuelType: 'Benzyna',
    power: '261 KM',
    featured: false,
    images: ['/images/toyota-gr-yaris-6751752_640.jpg']
  },
  {
    _id: '7',
    title: 'Porsche 911 GT3',
    description: 'Porsche Approved, pierwszy właściciel',
    price: 950000,
    year: 2023,
    mileage: 3000,
    fuelType: 'Benzyna',
    power: '510 KM',
    featured: false,
    images: ['/images/car-2616096_640.jpg']
  },
  {
    _id: '8',
    title: 'BMW M4 Competition',
    description: 'M Performance Parts, ceramic brakes',
    price: 520000,
    year: 2022,
    mileage: 18000,
    fuelType: 'Benzyna',
    power: '510 KM',
    featured: false,
    images: ['/images/auto-788747_1280.jpg']
  },
  {
    _id: '9',
    title: 'Audi RS e-tron GT',
    description: 'W pełni elektryczny, najwyższa wersja',
    price: 650000,
    year: 2023,
    mileage: 8000,
    fuelType: 'Elektryczny',
    power: '646 KM',
    featured: false,
    images: ['/images/automobile-1834278_640.jpg']
  },
  {
    _id: '10',
    title: 'Mercedes C63 AMG',
    description: 'AMG Performance Package, ceramika',
    price: 420000,
    year: 2022,
    mileage: 25000,
    fuelType: 'Benzyna',
    power: '510 KM',
    featured: false,
    images: ['/images/mercedes-benz-841465_1920.jpg']
  },
  {
    _id: '11',
    title: 'BMW M8 Competition',
    description: 'Individual, pełne wyposażenie',
    price: 750000,
    year: 2023,
    mileage: 10000,
    fuelType: 'Benzyna',
    power: '625 KM',
    featured: false,
    images: ['/images/road-6745746_1920.jpg']
  },
  {
    _id: '12',
    title: 'Porsche Cayman GT4 RS',
    description: 'Kolekcjonerski egzemplarz, bez przebiegu',
    price: 850000,
    year: 2023,
    mileage: 1000,
    fuelType: 'Benzyna',
    power: '500 KM',
    featured: false,
    images: ['/images/challenger-5880009_1920.jpg']
  }
];

const api = {
  getListings: async () => {
    await new Promise(resolve => setTimeout(resolve, 1000));
    return mockListings;
  }
};

export default api;